import { useContext } from "react";
import { CompanyContext } from "../Context/company/Company.context";

export const useCompany = () => useContext(CompanyContext);
